import Vue from "vue";
import { registerOptions } from "./FP.vue";
import AlIndex from "./views/AL.Index.vue";
import "./assets/scss/style.scss";

import { plugins } from "./plugins";
registerOptions(plugins);

new Vue({
  ...plugins,
  render: function(h) {
    return h(AlIndex);
  }
}).$mount("#app-root");

